import React, { Component, Fragment } from 'react';
import { Button, Grid, Checkbox, Portal, Segment } from 'semantic-ui-react';
import storage from 'helpers/storage';
import moment from 'moment-timezone';
import { safeWindowOpen, safeLocationHref } from 'helpers/pathValidator';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga4';
import captainPayO from 'images/corp_popup_captainpay_O.png';
import captainPayX from 'images/corp_popup_captainpay_X.png';
import popupWelfareCoupangcash from 'images/popup_welfare_coupangcash.png';
import { domain } from '../../config/domain';

// eslint-disable-next-line no-unused-vars
const homepageDomain = domain('homepage');

const surveyKey = 'surveyDontView';

moment.tz.setDefault('Asia/Seoul');

class SurveyModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      onlyOneDay: false,
      onlyWeek: false,
      onlyYear: false
    };
  }

  componentDidMount() {
    const surveyDontView = storage.get(surveyKey);
    const step = this.getStep();
    const pathname = window.location.href;
    const path = pathname.split('/').pop();
    if (path !== 'dashBoard' && window.location.pathname !== '/service/landing') {
      return;
    }
    if (!Object.keys(step).length) {
      storage.remove(surveyDontView);
      return;
    }
    if (!surveyDontView) {
      ReactGA.event({
        category: '설문',
        action: '팝업 호출'
      });
      this.setState({
        open: true
      });
    } else {
      const { date } = surveyDontView;
      if (moment(date).isBefore(moment())) {
        ReactGA.event({
          category: '설문',
          action: '팝업 호출'
        });
        this.setState({
          open: true
        });
        storage.remove(surveyKey);
      }
    }
  }

  open = () => {
    this.setState({
      open: true
    });
  };

  close = () => {
    const { onlyOneDay, onlyWeek, onlyYear } = this.state;
    if (onlyOneDay) {
      storage.set(surveyKey, {
        date: moment().endOf('days')
      });
    }
    if (onlyWeek) {
      storage.set(surveyKey, {
        date: moment().endOf('weeks')
      });
    }
    if (onlyYear) {
      storage.set(surveyKey, {
        date: moment().endOf('years')
      });
    }
    ReactGA.event({
      category: '설문',
      action: '팝업 닫기 클릭'
    });
    this.setState({
      open: false
    });
  };

  pageMove = (url) => {
    this.close();
    // Info: setTimeout이 없을 경우 다시 사이트로 돌아갔을 때 부자연스러운 현상 발생
    setTimeout(() => {
      safeWindowOpen(url, '_blank');
    }, 0);
  };

  closeOneDays = () => {
    this.setState(
      {
        onlyOneDay: true
      },
      () => this.close
    );
  };

  onChange = (e) => {
    if (e.target.innerText === '다시 보지 않기') {
      this.setState(
        (prevState) => ({
          onlyYear: !prevState.onlyYear
        }),
        () => {
          const { onlyYear } = this.state;
          if (onlyYear) {
            ReactGA.event({
              category: '설문',
              action: '오늘은 그만 보기 클릭'
            });
            this.close();
          }
        }
      );
    }
    if (e.target.innerText === '일주일 동안 안 보기') {
      this.setState(
        (prevState) => ({
          onlyWeek: !prevState.onlyWeek
        }),
        () => {
          const { onlyWeek } = this.state;
          if (onlyWeek) {
            ReactGA.event({
              category: '설문',
              action: '오늘은 그만 보기 클릭'
            });
            this.close();
          }
        }
      );
    }
    if (e.target.innerText === '오늘 그만 보기') {
      this.setState(
        (prevState) => ({
          onlyOneDay: !prevState.onlyOneDay
        }),
        () => {
          const { onlyOneDay } = this.state;
          if (onlyOneDay) {
            ReactGA.event({
              category: '설문',
              action: '오늘은 그만 보기 클릭'
            });
            this.close();
          }
        }
      );
    }
  };

  onClickImage = (e, url, type) => {
    if (e.target.tagName === 'SPAN') {
      ReactGA.event({
        category: '설문',
        action: '우측 상단 텍스트링크 클릭',
        value: 1
      });
    } else {
      ReactGA.event({
        category: '설문',
        action: '팝업 클릭',
        value: 1
      });
    }
    if (url) {
      if (type) {
        safeWindowOpen(url);
      } else {
        safeLocationHref(url);
      }
    }
  };

  getInfo = () => {
    const { user = {} } = storage.get('company') || {};
    if (user.company && user.company.useMypoint) return captainPayO;
    return captainPayX;
  };

  handleEventShow = (e) => {
    if (e.target.name === 'ezwel') {
      const url =
        'https://sikdae.com/inquiry?service=bizgift&utm_source=corp&utm_medium=popupbanner&utm_campaign=consultation&utm_content=brand_ad&utm_term=bizgift_thanksgiving_230828';
      window.open(url, '_blank');
    }
  };

  getStep = () => {
    const stepDays = [
      {
        startDate: '2025-08-11T00:00:00',
        endDate: '2025-09-07T23:59:59',
        showUrl: '/service/landing',
        isEventBtn: true,
        eventBtnText: '더 알아보기',
        surveyDontViewType: 'days',
        color: '#3D00BC',
        imageSrc: popupWelfareCoupangcash,
        imageWidth: '550px',
        pageMoveUrl:
          'https://sikdae.com/inquiry?service=welfare&utm_source=corp&utm_medium=popupbanner&utm_campaign=consultation&utm_content=welfare&utm_term=coupang'
      }
    ];

    // stepDays 배열 기반으로 동적으로 survey 객체 생성
    const survey = {};
    stepDays.forEach((stepDay, index) => {
      const stepKey = `step${index + 1}`;
      survey[stepKey] = (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
        <img
          name="popup_img"
          alt="popup_img"
          src={stepDay.imageSrc}
          style={{ width: stepDay.imageWidth || '550px', borderRadius: '7px 7px 0px 0px' }}
        />
      );
    });

    const { onlyYear, onlyWeek, onlyOneDay } = this.state;
    const step = {};
    stepDays.forEach((stepDay, i) => {
      const { startDate, endDate, showUrl, isEventBtn, eventBtnText, surveyDontViewType, color, pageMoveUrl } = stepDay;
      if (window.location.pathname !== showUrl) return;
      if (moment().isBetween(moment(startDate), moment(endDate))) {
        if (!Object.keys(step).length) {
          const surveyStep = survey[`step${i + 1}`];
          step.content = surveyStep;
          step.isEventBtn = isEventBtn;
          step.eventBtnText = eventBtnText;
          step.surveyDontViewType = surveyDontViewType;
          step.color = color;
          step.pageMoveUrl = pageMoveUrl;
          if (step.surveyDontViewType === 'years') {
            step.checkboxLabel = '다시 보지 않기';
            step.periodType = onlyYear;
          } else if (step.surveyDontViewType === 'weeks') {
            step.checkboxLabel = '일주일 동안 안 보기';
            step.periodType = onlyWeek;
          } else if (step.surveyDontViewType === 'days') {
            step.checkboxLabel = '오늘 그만 보기';
            step.periodType = onlyOneDay;
          }
        }
      }
    });
    return step; // Object.keys(step).length > 0 ? step : defaultStep;
  };

  render() {
    const { open } = this.state;
    const step = this.getStep();

    return (
      <span>
        {open ? (
          <Grid
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 10,
              opacity: 0.5,
              backgroundColor: 'rgb(0, 0, 0)',
              margin: 0
            }}
          />
        ) : null}
        <Fragment>
          <Portal
            size="small"
            open={open}
            onClose={this.close}
            closeOnDimmerClick={false}
            closeOnDocumentClick={false}
            closeOnEscape={false}
            style={{ width: 600 }}
          >
            <Segment
              style={{
                position: 'fixed',
                left: '50%',
                top: '50%',
                transform: 'translateY(-50%) translateX(-50%)',
                zIndex: 1000,
                padding: 0,
                boxShadow: 'rgb(111 111 111) 0px 5px 15px',
                border: 'none',
                borderRadius: '8px',
                margin: 0,
                minWidth: '550px'
              }}
            >
              <div>{open ? step.content : null}</div>
              <Grid style={{ padding: 8 }}>
                <Grid.Column floated="left" width={6}>
                  <Checkbox
                    label={step.checkboxLabel}
                    checked={step.periodType}
                    onChange={this.onChange}
                    style={{ padding: 8 }}
                  />
                </Grid.Column>
                <Grid.Column floated="right" width={8} style={{ textAlign: 'right' }}>
                  {step.isEventBtn ? (
                    <Button
                      className="ok"
                      onClick={() => this.pageMove(step.pageMoveUrl)}
                      style={{
                        width: '150px',
                        marginRight: 8,
                        padding: '12px 2px 10px',
                        color: '#FFFFFF',
                        backgroundColor: step.color,
                        border: `1px solid ${step.color}`,
                        // backgroundColor: '#1599e3',
                        // border: '1px solid #1599e3',
                        borderRadius: '4px'
                      }}
                    >
                      {step.eventBtnText}
                    </Button>
                  ) : null}
                  <Button
                    className="ok"
                    inverted
                    onClick={this.close}
                    style={{
                      marginRight: 8,
                      padding: '12px 21px 10px',
                      color: step.color,
                      border: 'solid 1px #D4D4D5',
                      borderRadius: '4px'
                    }}
                  >
                    닫기
                  </Button>
                </Grid.Column>
              </Grid>
            </Segment>
          </Portal>
        </Fragment>
      </span>
    );
  }
}

SurveyModal.contextTypes = {
  router: PropTypes.object.isRequired
};

export default SurveyModal;
